import styled from 'styled-components';

export const StyledContainer = styled.div`

  flex: 1 1 100%;

`;
